module.exports = __webpack_public_path__ + "static/img/interview-2-4.0259761.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-2-4.png
// module id = nPtj
// module chunks = 1